import pxToRem from "../../functions/pxToRem";

export default function inputOutlined({ colors, tokens, borders, typography }) {
  const { info, grey, transparent, background, error, text } = colors;
  const { borderRadius, borderWidth } = borders;
  const { size } = typography;

  const inputOutlined = {
    styleOverrides: {
      root: {
        backgroundColor: background.paper,
        fontSize: size.sm,
        borderRadius: borderRadius.lg,
        transition: "box-shadow 200ms ease-in-out, border-color 200ms ease-in-out",

        "&:hover .MuiOutlinedInput-notchedOutline": {
          borderColor: grey[400],
        },

        "&.Mui-focused": {
          "& .MuiOutlinedInput-notchedOutline": {
            borderColor: info.main,
            borderWidth: borderWidth[2],
          },
          boxShadow: `0 0 0 3px ${tokens["accent-soft-2"]}`,
        },

        "&.Mui-error": {
          "& .MuiOutlinedInput-notchedOutline": {
            borderColor: error.main,
          },
          boxShadow: `0 0 0 3px ${tokens["error-soft-2"]}`,
        },
      },

      notchedOutline: {
        borderColor: grey[300],
        borderWidth: borderWidth[1],
        transition: "border-color 200ms ease-in-out",
      },

      input: {
        color: text.primary,
        padding: `${pxToRem(14)} ${pxToRem(14)}`,
        backgroundColor: transparent.main,

        "&::placeholder": {
          color: grey[500],
          opacity: 1,
        },
      },

      inputSizeSmall: {
        fontSize: size.xs,
        padding: `${pxToRem(10)} ${pxToRem(12)}`,
      },

      multiline: {
        color: text.primary,
        padding: pxToRem(14),
      },
    },
  };

  return inputOutlined;
}
